/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import { FormTextFieldProps } from '../../../../client/js/components/form/fields/FormField'
import { parseNumber } from '@jalik/form-parser'
import MandateInput, { MandateInputProps } from '../inputs/MandateInput'

function MandateField (props: FormTextFieldProps & Partial<MandateInputProps>) {
  const { name = 'mandateId', ...others } = props

  const { errors, getFieldProps, handleSetValue } = useFormContext()
  const fieldProps = getFieldProps(name, others)

  return (
    <MandateInput
      error={errors[name]?.message}
      {...fieldProps}
      name={name}
      onChange={handleSetValue(name, { parse: parseNumber })}
    />
  )
}

export default MandateField
